import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69ce81e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "book-total-amount"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "결제금액", -1 /* HOISTED */))
const _hoisted_3 = { class: "value" }
const _hoisted_4 = {
  key: 0,
  class: "annotation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.totalBookAmount)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString($setup.useCurrencyFormat($props.totalBookAmount)) + "원", 1 /* TEXT */),
        (!$props.isMonthlyBook && $props.numberOfBookDates > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString($setup.useCurrencyFormat($props.oneTimeFare)) + "원x" + _toDisplayString($props.numberOfBookDates) + "일)", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}